module.exports = __webpack_public_path__ + "images/2033a504a5e0ec63025221d43df4d169.svg";